import ProductLandingTemplate from "./ProductLandingTemplate";

const product = {
  slug: "lakashitel",
  name: "Lakáshitel",
  description:
    "Hasonlítsd össze több bank lakáshitel ajánlatát, és dönts adatok alapján a legkedvezőbb konstrukció mellett.",
  highlights: [
    "Versenyképes kamatok több banktól",
    "Személyre szabott szakértői támogatás",
    "Átlátható, gyors online folyamat",
  ],
};

export default function LakashitelPage() {
  return (
    <ProductLandingTemplate
      product={product}
      iframeSrc="https://bankmonitor.hu/embed/szemelyi-hitel/?source=tasi_abel"
    />
  );
}
